import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/conclusion',
  redirect: 'noredirect',
  name: 'conclusion',
  component: Layout,
  children: [
    {
      path: 'conclusion',
      component: () => import('@/views/conclusion/index.vue'),
      name: 'conclusion',
      meta: {
        title: '结题汇报',
        requireAuth: true
      }
    },
  ]

}
export default equipRouter
